import { useTranslation } from 'react-i18next';

import { paths } from 'src/routes/paths';
import { useJsonLd } from 'src/hooks/use-json-ld';
import { CtaDuo } from 'src/components/cta-duo';
import { PageSeo } from 'src/components/page-seo';
import { StatsGrid } from 'src/components/stats-grid';
import { Manifesto } from 'src/components/manifesto';
import { SectionHead } from 'src/components/section-head';
import { NightTimeline } from 'src/components/night-timeline';

import { HomeFaq } from './home-faq';
import { HomeHero } from './home-hero';
import { HomeServices } from './home-services';
import { useHomeStructuredData } from './use-home-structured-data';

export function HomeView() {
  const { t } = useTranslation('home');
  const structuredData = useHomeStructuredData();

  useJsonLd(...structuredData);

  return (
    <>
      <PageSeo path={paths.home} title={t('meta.title')} description={t('meta.description')} />

      <HomeHero />

      <Manifesto ns="home" />

      <HomeServices />

      <section className="section tight-top">
        <div className="container">
          <StatsGrid items={t('stats.items', { returnObjects: true })} />
        </div>
      </section>

      <section className="section">
        <div className="container">
          <SectionHead
            lead={t('process.lead')}
            title={t('process.title')}
            eyebrow={t('process.eyebrow')}
          />
          <NightTimeline steps={t('process.steps', { returnObjects: true })} />
        </div>
      </section>

      <div role="presentation" className="horizon" />

      <HomeFaq />

      <section className="section day flush-top">
        <div className="container">
          <CtaDuo
            primary={{
              to: paths.contact,
              label: t('cta.primary.label'),
              title: t('cta.primary.title'),
              action: t('cta.primary.action'),
            }}
            secondary={{
              to: paths.services.secureAi,
              label: t('cta.secondary.label'),
              title: t('cta.secondary.title'),
              action: t('cta.secondary.action'),
            }}
          />
        </div>
      </section>
    </>
  );
}
